import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useDeleteStandingsConfiguration = () => {
  const { sport, organizationId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (standingConfigurationId: string) => {
      const url = `${sport}/o/${organizationId}/standings/configurations/${standingConfigurationId}`;
      return await request(url, {
        method: "DELETE",
      });
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["standingsConfigurations"] }),
        queryClient.invalidateQueries({ queryKey: ["standingsConfigurations", sport, organizationId] }),
      ]);
    },
  });
};
